import { render } from "./HeaderMiniBasic.vue?vue&type=template&id=ef496244&ts=true"
import script from "./HeaderMiniBasic.vue?vue&type=script&lang=ts"
export * from "./HeaderMiniBasic.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__